export enum GraphType {
    Gender = "gender",
    Age = "age",
}


export interface TreeNode {
    value: string;
    title: string;
    node_type: string;
    age_distribution: string;
    gender_distribution: string;
    unique_count: number;
    children: TreeNode[];
    path: string[];
    additional_values: string[]
}

export enum SelectedView {
    Diagnosis = "diagnosis",
    Procedures = "procedures",
    Questionnaires = "questionnaires",
}

export interface VersionData {
    version_id: string;
    timestamp: string;
}

export interface FetchDataResponse {
    diagnosis: VersionData[];
    procedures: VersionData[];
}